export default __webpack_public_path__ + "static/media/banner.a5c5247d.png";